import { createSvgIcon } from '@automata/mui-theme';
export const UncapIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34 21V38H62V21H34ZM33 18C31.8954 18 31 18.8954 31 20V39C31 40.1046 31.8954 41 33 41H63C64.1046 41 65 40.1046 65 39V20C65 18.8954 64.1046 18 63 18H33Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40 56V41H56V56H59V40C59 38.8954 58.1046 38 57 38H39C37.8954 38 37 38.8954 37 40V56H40ZM40 64H37V76C37 77.1046 37.8954 78 39 78H57C58.1046 78 59 77.1046 59 76V64H56V75H40V64Z"
    />
    <path d="M38 21H40V39H38V21Z" />
    <path d="M44 21H46V39H44V21Z" />
    <path d="M50 20.5H52V38.5H50V20.5Z" />
    <path d="M56 20H58V38H56V20Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74.1933 55.0979C74.2542 55.0644 74.3115 55.0317 74.3656 55C74.3115 54.9683 74.2542 54.9356 74.1933 54.9021C73.0221 54.2559 71.1286 53.5778 68.5315 52.9718C67.2055 52.6624 65.7391 52.3815 64.1538 52.135V49.1004C72.4807 50.3443 78 52.5218 78 55C78 58.866 64.5685 62 48 62C31.4315 62 18 58.866 18 55C18 52.5218 23.5192 50.3444 31.8461 49.1004V52.135C30.2608 52.3815 28.7945 52.6624 27.4685 52.9718C24.8714 53.5778 22.9779 54.2559 21.8067 54.9021C21.7458 54.9356 21.6885 54.9683 21.6344 55C21.6885 55.0317 21.7458 55.0644 21.8067 55.0979C22.9779 55.7441 24.8714 56.4222 27.4685 57.0282C32.6147 58.229 39.8752 59 48 59C56.1248 59 63.3853 58.229 68.5315 57.0282C71.1286 56.4222 73.0221 55.7441 74.1933 55.0979Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.6369 55.6677L60.9019 49.5821L69.4413 46.5035L67.6369 55.6677Z"
    />
  </svg>,
  'UncapIcon'
);
